import React, { useState } from 'react'
import CheckIcon from '@material-ui/icons/Check'
import { Dialog, DialogTitle, DialogContent, Button, TextField } from '@material-ui/core'

export const AgsArchiveButton = ({ record, onArchive }) => {
  const [dialogOpened, setDialogOpened] = useState(false)
  const [reason, setReason] = useState('')

  if (record.archived)
    return (
      <Button variant="outlined" color="secondary" disabled={true}>
        <CheckIcon /> Archivé
      </Button>
    )

  const handleArchive = () => {
    onArchive({ ...record, archived: true, archived_reason: reason })
    setDialogOpened(false)
  }

  return (
    <>
      <Button variant="contained" color="secondary" onClick={() => setDialogOpened(true)}>
        Archiver
      </Button>
      <Dialog open={dialogOpened} onClose={() => setDialogOpened(false)}>
        <DialogTitle>Archiver l'AG</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Raison"
            fullWidth
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
          <Button onClick={handleArchive} color="primary" variant="contained">
            Confirmer
          </Button>
        </DialogContent>
      </Dialog>
    </>
  )
}
export default AgsArchiveButton
